import type { QueryKey as QueryKeyTanstack } from '@tanstack/react-query';
import { queryClient } from 'config/queryClient';

export const resetSimilarQueriesButCurrent = (queryKey: QueryKeyTanstack) => {
  const campaignQueriesCache = queryClient.getQueryCache();
  const allCampaignQueries = campaignQueriesCache
    .getAll()
    .filter((q) => q.queryKey[0] === queryKey[0] && JSON.stringify(q.queryKey) !== JSON.stringify(queryKey));

  allCampaignQueries.forEach((q) => {
    queryClient.resetQueries(q.queryKey, { exact: true });
  });
};
